<template>
  <b-container>
    <b-row>
      <b-col>
        <!-- <b-form-group id="picture" label="Profile Picture:" label-for="picture-upload">
          <b-row>
            <b-col>
              <my-upload
                      langType="en"
                      field="img"
                      @crop-success="cropSuccess"
                      @crop-upload-success="cropUploadSuccess"
                      @crop-upload-fail="cropUploadFail"
                      v-model="show"
                      :width="200"
                      :height="200"
                      :params="params"
                      :headers="headers"
                      img-format="png"
                      no-square
                      >
              </my-upload>
            </b-col>
            <b-col>
              <a class="btn" @click="toggleShow">Change Profile Image</a>
            </b-col>
          </b-row>
        </b-form-group> -->
        <b-form-group id="name" label="Name:" label-for="name-input">
          <b-row>
            <b-col class="d-flex">
              <b-col class="col-11 pr-1 pl-0">
                <b-form-input
                  id="name-input"
                  v-model="firstname"
                  required
                  placeholder="First Name"
                ></b-form-input>
              </b-col>
              <b-col
                class="col-1 pl-0 pr-0"
                v-if="firstname !== profile.firstname && firstname"
              >
                <b-button
                  class="fas fa-save"
                  variant="primary"
                  @click="saveChangeData('firstname')"
                ></b-button>
              </b-col>
            </b-col>
            <b-col class="d-flex">
              <b-col class="col-11 pr-1 pl-0">
                <b-form-input
                  id="name-input"
                  v-model="lastname"
                  required
                  placeholder="Last Name"
                ></b-form-input>
              </b-col>
              <b-col
                class="col-1 pl-0 pr-0"
                v-if="lastname !== profile.lastname && lastname"
              >
                <b-button
                  class="fas fa-save"
                  variant="primary"
                  @click="saveChangeData('lastname')"
                ></b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="birthdate" label="Birth Date:" label-for="birth-date">
          <b-row>
            <b-col class="d-flex col-6">
              <b-col class="col-11 pr-1 pl-0">
                <b-form-input
                  id="birth-date"
                  type="date"
                  v-model="birthdate"
                  required
                  description="We'll never share your email with anyone else."
                ></b-form-input>
              </b-col>
              <b-col
                class="col-1 pl-0 pr-0"
                v-if="birthdate !== profile.birthdate && birthdate"
              >
                <b-button
                  class="fas fa-save"
                  variant="primary"
                  @click="saveChangeData('birthdate')"
                ></b-button>
              </b-col>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group id="email" label="Email:" label-for="email-input">
          <b-form-input
            id="email-input"
            v-model="email"
            required
            placeholder="email@email.com"
            :disabled="true"
            description="We'll never share your email with anyone else."
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="mainline"
          label="Main Line:"
          label-for="language-input"
        >
          <b-row class="d-flex">
            <b-col class="col-11 pr-1">
              <b-form-textarea
                id="textarea-no-auto-shrink"
                placeholder="What's your Main Line?"
                v-model="mainline"
                rows="3"
                max-rows="8"
                no-auto-shrink
              ></b-form-textarea>
            </b-col>
            <b-col
              class="col-1 pl-0 pr-0"
              v-if="mainline !== profile.mainline && mainline"
            >
              <b-button
                class="fas fa-save"
                variant="primary"
                @click="saveChangeData('mainline')"
              ></b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import firebase from "firebase";
export default {
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      // // debugger;
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
      console.log(imgDataUrl);
      //console.log(field);
      // // debugger;
      this.updateProfileImage(imgDataUrl);
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    updateProfileImage(imgDataUrl) {
      //Upload to server --
      //TODO:Move to store?
      // Create a root reference
      var storageRef = firebase
        .storage()
        .ref(`profile_img/${this.$store.state.user.user.uid}`);

      // Create file metadata including the content type
      var metadata = {
        contentType: "image/jpeg"
      };
      var uploadTask = storageRef.putString(imgDataUrl, "data_url");

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on(
        "state_changed",
        snapshot => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        error => {
          // Handle unsuccessful uploads
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$store
              .dispatch("user/updateProfile", { imgURL: downloadURL })
              .then(() => {
                this.$store.dispatch("user/getProfile").then(() => {
                  console.log("successfully saved at", downloadURL);
                });
              });
            //Update the url of the profile
          });
        }
      );
    },
    handleParentSave() {
      // // debugger;
    },
    handleParentReset() {
      // // debugger;
    },
    handleSubmitClick() {
      this.isEditingAbout = !this.isEditingAbout;
    },
    handleUpdateClick() {
      let profile = {};
      //TODO: Add Validation of Data
      //TODO: Add Ability to update Email
      //TODO: Add Ability to add and update skills

      /*if (this.firstname !==  this.user.profile.firstname) profile.firstname = this.firstname;
        if (this.lastname !==  this.user.profile.lastname) profile.lastname = this.lastname;
        if (this.username !==  this.user.profile.username) profile.username = this.username;
        if (this.about !==  this.user.profile.about) profile.about = this.about;
        if (this.phone !==  this.user.profile.phone) profile.phone = this.phone;
*/

      this.$store
        .dispatch("user/updateProfile", profile)
        .then(() => {
          this.$nprogress.done();
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    saveChangeData(type) {
      let dataToUpdate = { [type]: this[type] };
      console.log(type, this[type], this.profile[type]);
      this.$store.dispatch("user/updateProfile", dataToUpdate).then(res => {
        if (res) {
          this.$store.dispatch("user/getProfile").then(() => {
            console.log(`change ${type} success to ${this[type]}`);
          });
        }
      });
    }
  },
  computed: {
    hasUpdates() {
      return true;
      /*return this.firstname !==  this.user.profile ? this.user.profile.firstname : null ||
                this.lastname !==  this.user.profile ? this.user.profile.lastname : null ||
                this.username !==  this.user.profile ? this.user.profile.username : null ||
                this.about !==  this.user.profile ? this.user.profile.about : null ||
                this.phone !==  this.user.profile ? this.user.profile.phone : null ;*/
    }
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      show: false,
      params: {
        token: "123456798",
        name: "avatar"
      },
      headers: {
        smail: "*_~"
      },
      imgDataUrl: "", // the datebase64 url of created image
      firstname: this.profile ? this.profile.firstname : null,
      lastname: this.profile ? this.profile.lastname : null,
      username: null,
      birthdate:
        this.profile && this.profile.birthdate ? this.profile.birthdate : null,
      email: this.profile ? this.profile.email : null,
      about: this.profile ? this.profile.about : null,
      mainline: this.profile ? this.profile.mainline : null,
      skills: null,
      phone: null,
      skype: null,
      selected: null,
      optionsLanguages: [
        { value: null, text: "Please select your Language" },
        { value: "English (USA)", text: "English (USA)" }
      ],
      optionsTimezones: [
        { value: null, text: "Please select your TimeZone" },
        { value: "PST", text: "PST" }
      ],
      optionsSpiritual: [
        { value: null, text: "Please select your Language" },
        { value: "Baptist", text: "Baptist (USA)" }
      ],
      optionsPolitical: [
        { value: null, text: "Please select your Language" },
        { value: "Democrat", text: "Democrate" }
      ]
    };
  }
};
</script>
